import heroRetina from 'marketing-website/media/images/pages/homepage/00-hero-new@2x.jpg';
import caseStudiesRetina from 'marketing-website/media/images/pages/homepage/05-caseStudies@2x.png';

const assets = {
  hero: {
    alt: '',
    src: heroRetina,
    maxWidth: 762,
  },
  caseStudies: {
    alt: '',
    src: caseStudiesRetina,
    maxWidth: 1500,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/homepage/assets.js